var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",on:{"click":function($event){return _vm.$router.push({ path: `/${_vm.url}/${_vm.slug}` })}}},[_c('i',{staticClass:"d-flex fas fa-th right-icon",class:[_vm.isActive ? 'active-link-icon' : '']}),_c('i',{staticClass:"d-flex fas fa-list left-icon",class:[!_vm.isActive ? 'active-link-icon' : '']})])
}
var staticRenderFns = []

export { render, staticRenderFns }